<template>
  <apex-chart
    type="donut"
    :options="chartOptions"
    :series="chartSeries"
  />
</template>

<script>
export default {
  name: 'EmptyDonutPieChart',

  data() {
    return {
      chartSeries: [1],
      chartOptions: {
        chart: {
          type: 'donut',
          width: 380,
        },
        labels: [],
        colors: ['#9ca3af'],
        stroke: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        plotOptions: {
          pie: {
            donut: {
              size: '70%',
              background: 'transparent',
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  label: 'Total',
                  fontFamily: 'Inter, sans-serif',
                  formatter(w) {
                    return w.globals.seriesTotals
                      .reduce(() => {
                        return 0
                      }, 0)
                      .toFixed(2)
                  },
                },
                value: {
                  show: true,
                  fontSize: '20px',
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 600,
                  color: undefined,
                },
              },
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 380,
              },
              legend: {
                show: false,
              },
              dataLabels: {
                enabled: false,
              },
            },
          },
        ],
      },
    }
  },
}
</script>
